__turbopack_context__.v({
  "active": "index-module-scss-module__qIwUmG__active",
  "container": "index-module-scss-module__qIwUmG__container",
  "radioButton": "index-module-scss-module__qIwUmG__radioButton",
  "title": "index-module-scss-module__qIwUmG__title",
});
